export interface IRole {
  id: string;
  names: any;
  code: string;
}

export enum PermissionsEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  WAREHOUSE_MANAGER = 'WAREHOUSE_MANAGER',
  BRIGADE = 'BRIGADE',
  OPERATOR = 'OPERATOR',
  SALES = 'SALES',
  ACCOUNTANT = 'ACCOUNTANT',

  GUIDES = 'GUIDES',
  INCIDENTS_CREATE = 'INCIDENTS_CREATE',
  INCIDENTS_VIEW = 'INCIDENTS_VIEW',
  RESOURCES = 'RESOURCES',
  UPDATE_STATUS = 'INCIDENTS_STATUS_UPDATE',
}
